import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import './songItemWrapper.scss';
import defaultSongApplyIcon from './images/defaultSongApplyIcon.svg';
import {
  goToPage,
  setPopOverOpenId,
  setShowDownloadSongPopUp,
  setPageBackFromOtp,
  setSelectedSong,
  setErrorType,
  reportAnalytics,
} from '../../fundialSlice';
import {Col, Row, Container} from 'reactstrap';
import OptionsPopOver from './OptionsPopOver/OptionsPopOver';
import {showAppLoader, hideAppLoader} from '../../../../Shared/Loader/LoaderSlice';
import icSysbarMenu from './images/icSysbarMenu.svg';
import downloadIcon from './images/downloadIcon.svg';
const SongItemWrapper = (props) => {
  const songId = 'songId-' + props.songId;
  const isDefaultSong = props.isDefaultSong == 'true';

  function clickOptionBtn() {
    props.setPopOverOpenId(props.songId);
  }

  async function onClickDownloadSong() {
    props.reportAnalytics({
      eventCategory: 'fundial',
      eventAction: 'HN_PopUp_Download',
      eventLabel: '',
    });

    if (props.currentPage == 'songListPage') {
      props.reportAnalytics({
        eventCategory: 'fundial',
        eventAction: 'HN_ListCategories_Download',
        eventLabel: '',
      });
    }

    await props.setShowDownloadSongPopUp(false);
    await props.setSelectedSong(props.audio);

    if (!props.isAuthenticated) {
      props.setPageBackFromOtp({pageBackFromOtp: 'downloadSongPage'});
      props.goToPage({page: 'otpPage'});
    } else if (props.subscribers.length == 0) {
      props.setErrorType({errorType: 'GENERAL'});
      props.goToPage({page: 'errorPage'});
    } else if (
      props.subscribers.length == 1 &&
      props.selectedSubscriber &&
      props.selectedSubscriber.fundialSubscriberStatus == 'SUSPENDED'
    ) {
      props.setErrorType({errorType: 'SUBSCRIBER_ERROR'});
      props.goToPage({page: 'errorPage'});
    } else if (
      (!props.selectedSubscriber && props.subscribers.length > 1) ||
      (props.subscribers.length > 1 && props.selectedSubscriber && props.selectedSubscriber.fundialSubscriberStatus == 'SUSPENDED')
    ) {
      props.goToPage({page: 'subscriberListPage'});
    } else if (props.selectedSubscriber) {
      props.goToPage({page: 'downloadSongPage'});
    }
  }

  return (
    <div className='song-item-wrapper'>
      {props.children}
      {props.isDownloadMode && (
        <button
          onClick={() => {
            onClickDownloadSong();
          }}
          className='download-btn' style={{backgroundImage:downloadIcon.bg()}}></button>
      )}
      {props.isPlaylistMode && (
        <div className='options-wrapper' >
          <div className='options' >
            <button
              style={{backgroundImage:icSysbarMenu.bg()}}
              onClick={() => {
                clickOptionBtn();
              }}
              id={songId}></button>
            {isDefaultSong && <Image className='default-icon' src={defaultSongApplyIcon} />}
          </div>
          <OptionsPopOver target={songId} audio={props.audio} isDefaultSong={isDefaultSong} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {

  const {
    isOtpAuthenticated,
    isFullAuthenticated,
    isOtpExtendedAuthenticated,
    isSilentOtpAuthenticated
  } = state.authentication.loginData;

  return {
    isAuthenticated: isOtpAuthenticated || isFullAuthenticated || isOtpExtendedAuthenticated || isSilentOtpAuthenticated,
    selectedSubscriber: state.fundialPage.selectedSubscriber,
    subscribers: state.fundialPage.subscribers,
    currentPage: state.fundialPage.navigation.currentPage,
  };
};

const mapDispatchToProps = {
  goToPage,
  setPopOverOpenId,
  setShowDownloadSongPopUp,
  setPageBackFromOtp,
  setSelectedSong,
  showAppLoader,
  hideAppLoader,
  setErrorType,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(SongItemWrapper);
